<!-- Member "Add a photo" supply path. Login-gated; submissions are reviewed
     before they appear. -->
<section class="pa-wrap">
  <div class="wrap">
    <!-- Compact prompt: pick a photo first (camera or upload); a signed-out
         visitor is asked to sign in once they have chosen one, so the photo is
         kept while they do. -->
    <div class="pa-prompt" *ngIf="!open && !submitted">
      <span class="pa-prompt-text">Seen {{ displayRegistration || registration }} on a car?</span>
      <span class="pa-prompt-actions">
        <label class="pa-icon-btn" title="Take a photo" *ngIf="canCapture">
          <input type="file" accept="image/*" capture="environment" (change)="onPromptFile($event)" hidden />
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M4 8h3l2-3h6l2 3h3v11H4z" />
            <circle cx="12" cy="13" r="3.5" />
          </svg>
          <span class="pa-icon-label">Camera</span>
        </label>
        <label class="pa-icon-btn" title="Upload a photo">
          <input type="file" accept="image/*" (change)="onPromptFile($event)" hidden />
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M12 16V4" />
            <path d="M7 9l5-5 5 5" />
            <path d="M4 16v4h16v-4" />
          </svg>
          <span class="pa-icon-label">Upload</span>
        </label>
      </span>
    </div>

    <ng-container>
      <div class="pa-done" *ngIf="submitted">
        Thanks. Your photo is in review. You can see it on the timeline now,
        badged "Pending review"; it goes public once an editor approves it.
      </div>

      <form class="pa-form" *ngIf="open && !submitted" (ngSubmit)="submit()">
        <div class="pa-row">
          <span class="pa-label">Photo</span>
          <!-- Live preview once a photo is chosen. -->
          <div class="pa-preview" *ngIf="previewSafe">
            <img [src]="previewSafe" alt="Your photo" />
            <button type="button" class="pa-preview-x" (click)="clearPhoto()" aria-label="Remove photo">&times;</button>
          </div>
          <p class="pa-hint" *ngIf="previewSafe">
            Whole photo shown. We frame and crop it when it's published.
          </p>
          <div class="pa-photo">
            <!-- Phones and tablets only: opens the rear camera directly. Desktop
                 gets Choose (upload) only. -->
            <label class="pa-upload pa-upload--cam" *ngIf="canCapture">
              <input type="file" accept="image/*" capture="environment" (change)="onFile($event)" hidden />
              Take photo
            </label>
            <label class="pa-upload">
              <input type="file" accept="image/*" (change)="onFile($event)" hidden />
              Choose
            </label>
            <!-- "Paste a link" removed: the review service stores the photo
                 itself, so members upload the file. -->
          </div>
        </div>

        <div class="pa-row">
          <span class="pa-label">Which car is it on?</span>
          <select class="pa-input" [(ngModel)]="carChoice" name="carChoice">
            <option *ngFor="let c of knownCars; let i = index; trackBy: trackCar" [value]="'known:' + i">
              {{ c.label }}, from our records
            </option>
            <option value="other">Another car — add details</option>
          </select>
        </div>

        <div class="pa-car" *ngIf="addingNewCar">
          <div class="pa-grid2">
            <label class="pa-field">
              <span>Make</span>
              <input class="pa-input" [(ngModel)]="make" name="make" placeholder="Porsche" />
            </label>
            <label class="pa-field">
              <span>Colour</span>
              <input class="pa-input" [(ngModel)]="colour" name="colour" placeholder="Silver" />
            </label>
          </div>
          <label class="pa-field">
            <span>Model <em>(if known)</em></span>
            <input class="pa-input" [(ngModel)]="model" name="model" placeholder="911 Carrera" />
          </label>
        </div>

        <div class="pa-grid2">
          <label class="pa-field">
            <span>Year seen <em>(read from your photo)</em></span>
            <select class="pa-input" [(ngModel)]="year" name="year">
              <option *ngFor="let y of years" [value]="y">{{ y }}</option>
            </select>
          </label>
          <label class="pa-field pa-check">
            <input type="checkbox" [(ngModel)]="anonymous" name="anonymous" />
            <span>Post as "a PlateX user" <em>(hide my name)</em></span>
          </label>
        </div>

        <label class="pa-field" *ngIf="!anonymous">
          <span>Credit <em>(how you're named)</em></span>
          <input class="pa-input" [(ngModel)]="source" name="source" placeholder="@handle or your name" />
        </label>

        <label class="pa-consent">
          <input type="checkbox" [(ngModel)]="consent" name="consent" />
          <span>
            <strong>I took this photo, or I have the photographer's permission to share it.</strong>
            By sending it you allow PlateX to show it on this plate's page with the
            credit you choose. We check every photo before it appears and may crop
            it. Please avoid faces and other cars' number plates.
          </span>
        </label>

        <p class="pa-error" *ngIf="error">{{ error }}</p>

        <div class="pa-actions">
          <button type="button" class="pa-cancel" (click)="open = false">Cancel</button>
          <button type="submit" class="pa-submit" [disabled]="submitting || !consent">
            {{ submitting ? 'Submitting…' : 'Submit for review' }}
          </button>
        </div>
        <p class="pa-note">
          An editor confirms the plate and car before it appears. Shown with
          credit; removed on request of the rights holder.
        </p>
      </form>
    </ng-container>
  </div>
</section>
